module.exports = __webpack_public_path__ + "media/images/john-endecott-coin-a585cf8a8da18349f9d0006e8adccea4.png";